import { Link } from "react-router-dom";
import { ArrowRight, Home, LogIn } from "lucide-react";
import { Logo } from "@/components/brand/Logo";

export default function NotFound() {
  return (
    <div className="font-inter relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-[#0B1020] px-6 text-center text-white" data-testid="not-found-page">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-[#5B4BE6]/25 via-transparent to-transparent" />
      <div className="relative">
        <Link to="/" className="inline-block"><Logo variant="light" height={30} /></Link>
        <div className="mt-10 font-head text-[110px] font-extrabold leading-none tracking-tight text-transparent sm:text-[150px]" style={{ background: "linear-gradient(100deg,#7C6BFF,#A5B4FC,#5B4BE6)", WebkitBackgroundClip: "text", backgroundClip: "text" }}>404</div>
        <h1 className="mt-2 font-head text-2xl font-extrabold tracking-tight sm:text-3xl">This page took a detour.</h1>
        <p className="mx-auto mt-3 max-w-md text-[15px] leading-relaxed text-slate-400">
          The page you're looking for isn't here — but your path to funding still is. Let's get you back on track.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link to="/" data-testid="notfound-home" className="inline-flex items-center gap-2 rounded-xl bg-[#5B4BE6] px-6 py-3 text-sm font-semibold text-white shadow-[0_18px_50px_-20px_rgba(91,75,230,0.8)] transition-all hover:-translate-y-0.5 hover:bg-[#4F46E5]">
            <Home size={16} /> Back home
          </Link>
          <Link to="/login" data-testid="notfound-login" className="inline-flex items-center gap-2 rounded-xl border border-white/20 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/[0.06]">
            <LogIn size={16} /> Sign in
          </Link>
        </div>
        <Link to="/pricing" className="mt-6 inline-flex items-center gap-1.5 font-mono text-[11px] font-bold uppercase tracking-[0.18em] text-[#A5B4FC] hover:text-white">
          Explore membership plans <ArrowRight size={13} />
        </Link>
      </div>
      <div className="relative mt-14 font-mono text-[10px] uppercase tracking-[0.18em] text-slate-600">People. Plan. Opportunity.</div>
    </div>
  );
}
